module.exports = "img/flags/GG.4ab8b43.png";